// ===== Real forex/metals/indices/oil quotes via backend proxy (crypto comes from Binance) =====
import { MARKET, barStart, getState, hooks, symbolOf, setMarketQuote, setRealBars, round, log, emit } from "./store";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/market`;
const loaded = new Set();
let timer = null, failed = 0;

const setStatus = (s) => { if (getState().marketStatus !== s) { getState().marketStatus = s; emit(); } };

// Groups raw bars into the terminal's epoch-aligned buckets for the timeframe
// Daily source bars are stamped at the exchange's local midnight (e.g. 23:00 UTC), so shift before grouping
const bucket = (raw, tf) => {
  const shift = ["D1", "W1", "MN"].includes(tf) ? 3 * 36e5 : 0;
  const out = [];
  raw.forEach((b) => {
    const t = barStart(tf, b.t + shift);
    const last = out[out.length - 1];
    if (last && last.t === t) { last.h = Math.max(last.h, b.h); last.l = Math.min(last.l, b.l); last.c = b.c; last.v += b.v; }
    else out.push({ ...b, t });
  });
  return out.slice(-1000);
};

const loadBars = async (sym, tf) => {
  const key = `${sym}|${tf}`;
  if (!MARKET[sym] || !symbolOf(sym).anchored || loaded.has(key)) return;
  loaded.add(key);
  try {
    const r = await fetch(`${API}/bars?symbol=${sym}&tf=${tf}`);
    const raw = r.ok ? await r.json() : [];
    if (!raw.length) throw new Error("empty");
    const s = symbolOf(sym);
    const bars = bucket(raw, tf).map((b) => ({ ...b, o: round(b.o - s.half, s.digits), h: round(b.h - s.half, s.digits), l: round(b.l - s.half, s.digits), c: round(b.c - s.half, s.digits) }));
    setRealBars(sym, tf, bars);
  } catch (e) { loaded.delete(key); }
};

const poll = async () => {
  try {
    const r = await fetch(`${API}/quotes`);
    if (!r.ok) throw new Error(r.status);
    const q = await r.json();
    const fresh = Object.entries(q).filter(([sym]) => !symbolOf(sym).anchored).map(([sym]) => sym);
    Object.entries(q).forEach(([sym, v]) => setMarketQuote(sym, v.price, v.prev, v.time));
    if (failed || getState().marketStatus !== "live") log(`market data connected (${Object.keys(q).length} symbols)`, "Network");
    failed = 0;
    setStatus("live");
    if (fresh.length) getState().charts.forEach((c) => fresh.includes(c.symbol) && loadBars(c.symbol, c.tf));
  } catch (e) {
    if (!failed++) log("market data unavailable, retrying", "Network");
    setStatus("reconnecting");
  }
  timer = setTimeout(poll, 4000);
};

export const startMarkets = () => {
  if (timer) return;
  hooks.marketSeries = loadBars;
  setStatus("connecting");
  poll();
};
